

export class DeviceModelPortAllocationOutputWithStatus implements IDeviceModelPortAllocationOutputWithStatus {
    /** The auto-generated id of the deviceModelPortAllocation master */
    device_model_port_allocation_id!: number;
    /** The deviceModelPortAllocation name with 255 character limit */
    device_model_port_allocation_name!: string;
    /** Manage status of deviceModelPortAllocation. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IDeviceModelPortAllocationOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_model_port_allocation_id = _data["device_model_port_allocation_id"];
            this.device_model_port_allocation_name = _data["device_model_port_allocation_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeviceModelPortAllocationOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelPortAllocationOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_model_port_allocation_id"] = this.device_model_port_allocation_id;
        data["device_model_port_allocation_name"] = this.device_model_port_allocation_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDeviceModelPortAllocationOutputWithStatus {
    /** The auto-generated id of the deviceModelPortAllocation master */
    device_model_port_allocation_id: number;
    /** The deviceModelPortAllocation name with 255 character limit */
    device_model_port_allocation_name: string;
    /** Manage status of deviceModelPortAllocation. 0 For De-active, 1 For Active */
    status: number;
}

